<!-- src/components/dev/Dev.vue -->
<template>
    <div v-if="isDev">
      <slot />
    </div>
  </template>
  
  <script>
  export default {
    name: 'Dev',
    computed: {
      isDev() {
        return import.meta.env.MODE === 'development';
      }
    }
  };
  </script>